<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small'
                 class='query-form' @submit.native.prevent>
            <el-form-item label='数值类型'>
                <el-select
                    v-model="queryForm.valueType"
                    placeholder="请选择数值类型"
                    clearable
                    size="small"
                    style="width: 200px"
                >
                    <el-option v-for="item in globalvalueTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label='全局数值'>
                <el-input v-model='queryForm.globalValue' style="width: 200px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getMppGlobalvalueList'>查询
                </el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetDialog'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='addMppGlobalvalue'
                    >新建
                    </el-button>
                    <el-button
                        type='warning'
                        plain
                        size='small'
                        icon='el-icon-edit'
                        :disabled='multipleSelection.length != 1'
                        @click='editMppGlobalvalue(null)'
                    >修改
                    </el-button>
                    <el-button
                        type='danger'
                        plain
                        size='small'
                        icon='el-icon-delete'
                        :disabled='multipleSelection.length <= 0'
                        @click='deleteMppGlobalvalue(null)'
                    >删除
                    </el-button>
                </div>
                <div>点击查询展示数据</div>
                <div class='icon-group'>
                    <el-upload v-if='this.isImportDate'
                               class='upload-demo'
                               action='#'
                               :http-request='upload'
                               :show-file-list='true'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='search'
                    >
          <Icon color='#606266'>
            <Search />
          </Icon>
        </span>
                    <!--        <span-->
                    <!--          title="下载模板"-->
                    <!--          class="icon-box"-->
                    <!--          @click="importTemplate"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDown />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          class="icon-box"-->
                    <!--          title="导入数据"-->
                    <!--          @click="isImport"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowExportUp24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <!--        <span-->
                    <!--          title="导出数据"-->
                    <!--          class="icon-box"-->
                    <!--          @click="exportMppGlobalvalueList"-->
                    <!--        >-->
                    <!--          <Icon color="#606266">-->
                    <!--            <ArrowDownload24Regular />-->
                    <!--          </Icon>-->
                    <!--        </span>-->
                    <span
                        class='icon-box'
                        @click='refreshMppGlobalvalueList'
                    >
          <Icon color='#606266'>
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data='mppGlobalvalueList'
                row-key='id'
                border
                height='100%'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change='handleSelectionChange'
                size='small'
            >
                <el-table-column
                    align='center'
                    type='selection'
                    width='60'
                ></el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='valueType'
                    label='数据名称'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div>{{computeGlobalvalueType(scop.row.valueType)}}</div>
                    </template>
                </el-table-column>
                <el-table-column
                    :show-overflow-tooltip='true'
                    align='center'
                    prop='globalValue'
                    label='全局数值'
                    width='300'
                ></el-table-column>
				<el-table-column
				    :show-overflow-tooltip='true'
				    align='center'
				    prop='todayValue'
				    label='今日数值'
				    width='300'
				></el-table-column>
                <el-table-column
                    fixed='right'
                    align='center'
                    label='操作'
                    width='300'
                >
                    <template slot-scope='scop'>
                        <div class='operation'>
                            <div @click='showGlobalvalueRecord(scop.row.valueType)'>
                                <Icon size='16'>
                                    <Eye24Regular />
                                </Icon>
                                <span class='operation-label'>查看记录</span>
                            </div>
                            <div @click='editMppGlobalvalue(scop.row.id)'>
                                <Icon size='16'>
                                    <Edit24Regular />
                                </Icon>
                                <span class='operation-label'>修改</span>
                            </div>
                            <div @click='deleteMppGlobalvalue(scop.row.id)'>
                                <Icon size='16' style='color: red'>
                                    <Delete24Regular />
                                </Icon>
                                <span class='operation-label' style='color: red'>删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='sizeChange'
                    @current-change='currentChange'
                    :current-page.sync='currentPage'
                    :page-sizes='[15, 20, 50, 100]'
                    :page-size='pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='totalNum'
                    background
                    :pager-count='7'
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title='mppGlobalvalueStates[mppGlobalvalueState]'
                :visible.sync='showDialog'
                width='60%'
                @close='closeDialog'
            >
                <div>
                    <el-form
                        :model='mppGlobalvalue'
                        ref='mppGlobalvalueForm'
                        :rules='rules'
                        label-width='120px'
                        :inline='true'
                        size='small'
                    >
                        <el-form-item
                            label='数据名称'
                            prop='valueType'
                        >
                            <el-select
                                v-model="mppGlobalvalue.valueType"
                                :disabled="mppGlobalvalueState == 'check'"
                                placeholder="请选择数据名称"
                                clearable
                                size="small"
                                style="width: 200px"
                            >
                                <el-option v-for="item in globalvalueTypeEnumList" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item
                            label='全局数值'
                            prop='globalValue'
                        >
                            <el-input
                                size='small'
                                style="width: 200px"
                                v-model='mppGlobalvalue.globalValue'
                                :disabled="mppGlobalvalueState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label='今日数值'
                            prop='todayValue'
                        >
                            <el-input
                                size='small'
                                style="width: 200px"
                                v-model='mppGlobalvalue.todayValue'
                                :disabled="mppGlobalvalueState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot='footer'
                    class='flex justify-end'
                >
                    <el-button @click='closeDialog'>关闭</el-button>
                    <el-button
                        type='primary'
                        @click='submitForm'
                        v-if="mppGlobalvalueState != 'check'"
                    >确定
                    </el-button>
                </div>
            </el-dialog>
            <el-drawer
                title="抽奖纪录"
                :visible.sync="recordStatus"
                direction="rtl"
                size="70%"
                :before-close="closeGlobalvalueRecord">
                <GlobalvalueRecord :valueType='valueType' ref='GlobalvalueRecord'></GlobalvalueRecord>
            </el-drawer>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GlobalvalueRecord from './GlobalvalueRecord.vue';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GlobalvalueRecord
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetMppGlobalvalueList();
                this.getMppGlobalvalueList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetMppGlobalvalueList();
                this.getMppGlobalvalueList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            recordStatus: false,
            valueType: 0,
            globalvalueTypeEnumList: [],

            queryForm: {
                valueName: '', //数值名称
                valueType: '', //数值类型
                globalValue: '', //全局数值
                todayValue: '',
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 15,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            mppGlobalvalueState: 'add',
            mppGlobalvalueStates: {
                add: '新建全局数据',
                check: '查看全局数据',
                edit: '修改全局数据'
            },

            multipleSelection: [],
            mppGlobalvalueList: [],
            mppGlobalvalue: {
                valueName: '', //数值名称
                valueType: '', //数值类型
                globalValue: '', //全局数值
                todayValue: '',
            },
            btnLoading: false,

            rules: {
                valueName: [{ required: true, message: '数值名称不能为空', trigger: 'blur' }],
                valueType: [{ required: true, message: '数值类型不能为空', trigger: 'blur' }],
                globalValue: [{ required: true, message: '全局数值不能为空', trigger: 'blur' }],
                todayValue: [{ required: true, message: '今日数值不能为空', trigger: 'blur' }]
            }
        };
    },
    created() {
        // this.getMppGlobalvalueList();
        this.getGlobalvalueTypeEnum();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
        },
        resetMppGlobalvalueList() {
            this.pageSize = 15;
            this.currentPage = 1;
            this.mppGlobalvalueList = [];
        },
        resetDialog() {
            this.mppGlobalvalueState = 'add';
            this.showDialog = false;
            this.queryForm = {
                valueName: '', //数值名称
                valueType: '', //数值类型
                globalValue: '', //全局数值
            };
            this.getMppGlobalvalueList();
        },
        closeDialog() {
            this.showDialog = false;
            this.mppGlobalvalue = {
                valueName: '', //数值名称
                valueType: '', //数值类型
                globalValue: '', //全局数值
                todayValue: ''
            };
        },
        submitForm() {
            if (this.mppGlobalvalueState == 'add') {
                this.$refs.mppGlobalvalueForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/globalvalue/add`, { ...this.mppGlobalvalue }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGlobalvalueList();
                                this.resetDialog();
                                this.getMppGlobalvalueList();
                            }
                        });
                    }
                });
            } else if (this.mppGlobalvalueState == 'edit') {
                this.$refs.mppGlobalvalueForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/mpp/globalvalue/edit`, { ...this.mppGlobalvalue }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetMppGlobalvalueList();
                                this.resetDialog();
                                this.getMppGlobalvalueList();
                            }
                        });
                    }
                });
            }
        },
        addMppGlobalvalue() {
            this.showDialog = true;
            this.mppGlobalvalueState = 'add';
        },
        checkMppGlobalvalue(mppGlobalvalueId) {
            console.log(mppGlobalvalueId);
            this.currentMppGlobalvalueId = mppGlobalvalueId;

            this.getMppGlobalvalueById();
            this.showDialog = true;
            this.mppGlobalvalueState = 'check';
        },
        editMppGlobalvalue(mppGlobalvalueId) {
            console.log('mppGlobalvalue', mppGlobalvalueId);
            if (mppGlobalvalueId) {
                this.currentMppGlobalvalueId = mppGlobalvalueId;
                this.getMppGlobalvalueById();
            } else {
                this.mppGlobalvalue = { ...this.mppGlobalvalue, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.mppGlobalvalueState = 'edit';
        },
        deleteMppGlobalvalue(mppGlobalvalueId) {
            let ids = '';
            if (mppGlobalvalueId) {
                ids = mppGlobalvalueId;
            } else {
                ids = this.multipleSelection.map((mppGlobalvalue) => mppGlobalvalue.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/mpp/globalvalue/delete`, { ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetMppGlobalvalueList();
                            this.getMppGlobalvalueList();
                        }
                    });
                })
                .catch(() => {
                });
        },
        refreshMppGlobalvalueList() {
            this.resetMppGlobalvalueList();
            this.getMppGlobalvalueList();
        },
        getMppGlobalvalueList(query = {}) {
            this.loading = true;
            get(`/mpp/globalvalue/findList`, {
                ...this.queryForm,
                pageNum: this.currentPage,
                pageSize: this.pageSize
            }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.mppGlobalvalueList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getMppGlobalvalueById() {
            get(`/mpp/globalvalue/get`, { id: this.currentMppGlobalvalueId }).then((res) => {
                if (res.success) {
                    this.mppGlobalvalue = { ...this.mppGlobalvalue, ...res.mppGlobalvalue };
                }
            });
        },
        /**
         * 导出信息
         */
        exportMppGlobalvalueList() {
            //this.btnLoading = true;
            exprotExcel(`/mpp/globalvalue/export`, { ...this.queryForm });
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/globalvalue/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/globalvalue/importData`, formData);
            this.refreshMppGlobalvalueList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getMppGlobalvalueList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getMppGlobalvalueList();
        },

        // 获取GlobalvalueTypeEnum
        getGlobalvalueTypeEnum(){
            get('/mpp/utils/getEnum',{
                enumType: 'globalvalue_type'
            }).then((res)=>{
                if(res.success && res.code === 200){
                    this.globalvalueTypeEnumList = res.enumList
                }
            })
        },

        // 计算computeGlobalvalue
        computeGlobalvalueType(type){
            for (let i = 0; i < this.globalvalueTypeEnumList.length; i++) {
                if(this.globalvalueTypeEnumList[i].key === type){
                    return this.globalvalueTypeEnumList[i].value
                }
            }
        },

        showGlobalvalueRecord(id){
            this.valueType = id
            this.recordStatus = true
            this.$nextTick(()=>{
                this.$refs.GlobalvalueRecord.getMppGlobalvalueRecordList();
            })
        },

        closeGlobalvalueRecord(){
            this.recordStatus = false
        }
    }

};
</script>

<style lang='scss' scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>